<template>
  <button :class="buttonClass" :type="type" @click="click" @mousedown="$emit('mousedown')">
    <slot></slot>
  </button>
</template>

<script>
import { buttonClass } from "../prefix";
export default {
  props: {
    type: {
      default: "button",
    },
    buttonStyle: {
      default: "raised",
    },
    disabled: {
      default: false,
      type: Boolean,
    },
  },
  computed: {
    buttonClass() {
      return [buttonClass, { disabled: this.disabled }, `mad-${this.buttonStyle}-button`];
    },
  },
  methods: {
    click() {
      this.$emit("click");
    },
  },
};
</script>

<style lang="scss">
@import "../scss/import.scss";
$raised-button: $prefix + "-raised-button";
$color-button: $prefix + "-color-button";
$flat-button: $prefix + "-flat-button";

button {
  .mdi {
    font-size: 18px;
    vertical-align: middle;
    display: inline;
    margin-right: 8px;
    &.right {
      margin-right: 0;
      margin-left: 8px;
    }

    & svg {
      width: 18px !important;
      height: 18px !important;
    }
  }
}
button#{$raised-button} {
  margin: 0;
  min-width: 100px;
  font-weight: 700;
  text-transform: uppercase;
  outline: none;
  cursor: pointer;
  border-radius: 2px;
  padding: 12px 20px;
  line-height: 18px;
  border: 0;
  color: $theme-primary;
  background: white;
  letter-spacing: -0.1px;
  background: linear-gradient(65deg, #f1f1f1 0, #ffffff 100%);
  background: $theme-primary;
  box-shadow: 0 2px 4px rgba($theme-primary, 0.12);
  font-size: 12px;
  z-index: 1;
  transition: box-shadow 0.15s ease;
  margin: 0 4px;
  height: 42px;

  &::before {
    border-radius: 2px;
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    box-shadow: 0 8px 16px rgba($theme-primary-800, 0);
    mix-blend-mode: multiply;
    transition: box-shadow 0.15s ease;
  }

  &:hover {
    box-shadow: 0 8px 16px rgba(#a1a1a1, 0.24);
    &::before {
      box-shadow: 0 8px 16px rgba(#a1a1a1, 0.32);
    }
  }

  &.primary {
    background: $theme-primary;
    color: white;
    // background: $theme-primary-gradient-1;

    &::before {
      box-shadow: 0 8px 16px rgba(32, 41, 50, 0);
    }

    &:hover {
      box-shadow: 0 8px 16px rgba($theme-primary-800, 0.24);
      &::before {
        box-shadow: 0 8px 16px rgba($theme-primary-800, 0.32);
      }
    }
  }

  &.disabled {
    pointer-events: none;
    background: $color-grey-300;
    color: $color-grey-500;
    box-shadow: none;

    &::before {
      box-shadow: none;
    }
  }
}

button#{$color-button} {
  margin: 0;
  min-width: 100px;
  font-weight: 700;
  text-transform: uppercase;
  outline: none;
  cursor: pointer;
  border-radius: 2px;
  padding: 12px 20px;
  border: 0;
  color: $theme-primary;
  background: white;
  letter-spacing: -0.1px;
  background: $color-grey-200;
  box-shadow: none;
  font-size: 12px;
  line-height: 18px;
  height: 42px;
  z-index: 1;
  transition: box-shadow 0.15s ease;
  margin: 0 4px;

  &::before {
    border-radius: 2px;
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    box-shadow: none;
    mix-blend-mode: multiply;
    transition: box-shadow 0.15s ease;
  }

  &:hover {
    box-shadow: none;
    background: $color-grey-300;
  }

  &.primary {
    background: $theme-primary;
    color: white;

    &:hover {
      box-shadow: $theme-primary-600;
    }
  }

  &.disabled {
    pointer-events: none;
    background: $color-grey-300;
    color: $color-grey-500;
    box-shadow: none;

    &::before {
      box-shadow: none;
    }
  }
}

button#{$flat-button} {
  margin: 0;
  min-width: 100px;
  font-weight: 700;
  text-transform: uppercase;
  outline: none;
  cursor: pointer;
  border-radius: 2px;
  padding: 12px 20px;
  border: 0;
  color: $theme-primary;
  letter-spacing: -0.1px;
  box-shadow: none;
  font-size: 12px;
  z-index: 1;
  transition: box-shadow 0.15s ease;
  margin: 0 4px;
  background: transparent;
  height: 48px;
  line-height: 18px;

  &::before {
    border-radius: 2px;
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    box-shadow: none;
    mix-blend-mode: multiply;
    transition: box-shadow 0.15s ease;
  }

  &.primary {
    color: $theme-primary;
  }

  &.disabled {
    pointer-events: none;
    background: $color-grey-300;
    color: $color-grey-500;
    box-shadow: none;

    &::before {
      box-shadow: none;
    }
  }
}

.button-block {
  button:nth-last-child(1) {
    margin-right: 0 !important;
  }
}

// button#{$raised-button} {
//     margin: 0;
//     min-width: 100px;
//     font-weight: 700;
//     text-transform: uppercase;
//     outline: none;
//     cursor: pointer;
//     border-radius: 2px;
//     padding: 12px 20px;
//     border: 0;
//     color: #ffffff;
//     background: #5346DA;
//     letter-spacing: -0.1px;
//     background: linear-gradient(65deg, #3525D3 0, #7266E0 100%);
//     box-shadow: 0 2px 4px rgba(16,31,59,0.12);
//     font-size: 12px;
//     z-index: 1;

//     &::before {
//         border-radius: 2px;
//         content: '';
//         position: absolute;
//         top: 0;
//         right: 0;
//         bottom: 0;
//         left: 0;
//         box-shadow: 0 8px 16px rgba(32,41,50,0.12);
//         mix-blend-mode: multiply;
//         transition: box-shadow .15s ease;
//     }

//     &:hover {
//         box-shadow: 0 8px 16px rgba(53,37,211,0.24);
//         &::before {
//             box-shadow: 0 8px 16px rgba(53,37,211,0.32);
//         }
//     }
// }
</style>
